import LoadingSpinner from "../icons/LoadingSpinner";

export const ScreenLoader = () => {
  return (
    <div className="fixed top-0 left-0 right-0 bottom-0 bg-white bg-opacity-50 flex items-center justify-center">
      <LoadingSpinner className="w-24 h-24 text-purple"  />
    </div>
  );
};
